var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('AboutHeader'),_c('HeadCard'),_c('section',{staticClass:"trending-section"},[_c('EventCard',{attrs:{"events":_vm.events,"label":"What's Trending","link":"/experience"}})],1),_c('ListProperity')],1)}
var staticRenderFns = []

export { render, staticRenderFns }